import { SensitiveDataResponse } from "apis/sensitiveData";
import { MouseEvent } from "react";
import { SensitiveDataCopyButton } from "components/SensitiveData/SensitiveDataCopyButton";
import { SENSITIVE_DATA_MASKED_VALUE } from "constants/sensitiveData";
import { getSensitiveDataPrimaryField } from "util/getSensitiveDataPrimaryField";
import { getSensitiveDataRowCopyField } from "util/getSensitiveDataRowCopyField";

export const SensitiveDataValueCell = ({
  record,
}: {
  record: SensitiveDataResponse;
}) => {
  const primaryField = getSensitiveDataPrimaryField(record.form_data);
  const displayValue = primaryField?.value_display;

  if (!primaryField || !displayValue) {
    return <span className="t-text-body-sm">-</span>;
  }

  const copyField = getSensitiveDataRowCopyField(record);

  const handleCopyClick = (event: MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
  };

  return (
    <span className="t-flex t-items-center t-gap-1">
      <span className="t-text-body t-text-text-60">
        {SENSITIVE_DATA_MASKED_VALUE}
      </span>
      {copyField && (
        <span onClick={handleCopyClick}>
          <SensitiveDataCopyButton
            formId={record.uuid}
            attributeId={copyField.uuid}
            value={
              copyField.is_encrypted ? undefined : copyField.value_display ?? ""
            }
          />
        </span>
      )}
    </span>
  );
};
